import { isBiometricAvailable } from '@/shared/lib/platform/biometric'
import {
  getPlatform as detectPlatform,
  isNativePlatform as detectIsNativePlatform,
} from '@/shared/lib/platform/platformDetection'

/** Detecta plataforma de execução em runtime. */
export interface PlatformAPI {
  isNativePlatform(): boolean
  getPlatform(): 'web' | 'android' | 'ios'
  /** Alias semântico de {@link isNativePlatform}. */
  isNative(): boolean
}

/** Capabilities derivadas — usadas pelas feature flags. */
export interface PlatformCapabilities {
  /** IA local (WebLLM) só na PWA — D-02. */
  canRunLocalAI(): boolean
  /** Web Push (FCM via service worker) só na PWA — D-03. */
  canReceiveWebPush(): boolean
  /** Prompt beforeinstallprompt só fora do shell nativo. */
  canShowPwaInstallPrompt(): boolean
  /** Biometria nativa (plugin dedicado em T-BIO-01); web permanece false. */
  canUseBiometric(): Promise<boolean>
}

const createPlatform = (): PlatformAPI & PlatformCapabilities => ({
  isNativePlatform: () => detectIsNativePlatform(),
  getPlatform: () => detectPlatform(),
  isNative: () => detectIsNativePlatform(),
  canRunLocalAI: () => !detectIsNativePlatform(),
  canReceiveWebPush: () => !detectIsNativePlatform(),
  canShowPwaInstallPrompt: () => !detectIsNativePlatform(),
  canUseBiometric: async () => {
    if (!detectIsNativePlatform()) {
      return false
    }
    return isBiometricAvailable()
  },
})

/** API canônica de plataforma (singleton avaliado sob demanda por chamada). */
export const platform: PlatformAPI & PlatformCapabilities = createPlatform()
